<template>
    <keep-alive >
        <router-view />
    </keep-alive>
</template>

<script>
import {route_addLangToPath_s, route_getUrlData_fo, route_moveToRoute} from "../router";
    import {store_var, store_setStateValue, store_getStateValue_vo} from "../store";
    import {ass_navTabs} from "../assets/scripts/Ass_NavTabs";
    import {enum_moveToOptions} from "../../functions/src/shareCode/Share_S_Enum";
    import {ass_img_info_b} from "../assets/scripts/Ass_Files";
    import {ass_strings} from "../../functions/src/shareCode/Share_Ass_Dictionary";
import {
    serverAuth_currentUserData_get_vl_fp,
    serverAuth_currentUserData_remove_vl_f, serverAuth_getOtherUserData_f
} from "@/scripts/Server/S_ServerAuth";
import {FB_QuestEvent, FB_QuestPointer} from "../../functions/src/shareCode/Share_S_Classes";
import {obj_forEach_f} from "../../functions/src/shareCode/Share_S_Obj";
    export default {
        name: "V_Creator",
        data(){
            return{
                server_storeChats_byId_c : {},
                server_userData_c : undefined,

                store_system_langCode_ve : store_getStateValue_vo(store_var.system_langCode),
                server_userData_byUserId_c : store_getStateValue_vo(store_var.system_langCode),
            }
        },

        // life circle
        created(){

            serverAuth_currentUserData_get_vl_fp(this.$options.name, (userData_c) => {
                this.server_userData_c = userData_c

                // set navBar
                let ans = userData_c != null && !userData_c.ud_m_guestUser_b()
                        ? [ass_navTabs.creator_edit, ass_navTabs.creator_events, ass_navTabs.creator_profile]
                        : []
                store_setStateValue(store_var.navBar_tabs_ac, ans, false)

                // set navBar menu
                store_setStateValue(store_var.navBar_menu_ac, [
                    {img_r : ass_img_info_b, text_blc_s : ass_strings.oneWord_about,  onClickDo_f : () => { route_moveToRoute(enum_moveToOptions.standAlong_about)}}
                ])
            })

        },
        destroyed() {
            serverAuth_currentUserData_remove_vl_f(this.$options.name)
        },

        // route
        beforeRouteEnter(to, from, next){
            serverAuth_currentUserData_get_vl_fp(to.fullPath, (currentUser_c) => {

                if(currentUser_c === undefined){
                    return
                }

                // 2.0) remove listener
                serverAuth_currentUserData_remove_vl_f(to.fullPath)

                // 2.1) not login => profile page
                if (!currentUser_c || currentUser_c.ud_m_guestUser_b()) {
                    if(!to.fullPath.includes(enum_moveToOptions.creator_profile)){
                        next(route_addLangToPath_s(enum_moveToOptions.creator_profile))
                    }else{
                        next()
                    }
                    return
                }

                // 2.4) creator edit
                if(to.fullPath.includes(enum_moveToOptions.creator_edit)){

                    // 2.1.1) creator edit item
                    if(to.fullPath.includes(enum_moveToOptions.creator_edit_item)){

                        try{
                            new FB_QuestPointer(route_getUrlData_fo(to))
                        }
                        catch(err){
                            console.log(err)
                            route_moveToRoute(enum_moveToOptions.creator_edit_list)
                            return
                        }
                    }
                }

                // 2.5) creator event item
                if(to.fullPath.includes(enum_moveToOptions.creator_events_item)){
                    try{
                        new FB_QuestEvent(store_getStateValue_vo(store_var.creator_events_selectedEvent_c).val)
                    }
                    catch(err){
                        console.log(err)
                        route_moveToRoute(route_addLangToPath_s(enum_moveToOptions.creator_events_list))
                    }
                }

                next()
            })
        },

    }
</script>

<style scoped>

</style>